import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconTrashX, IconDeviceFloppy } from '@tabler/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { openDeleteConfirmModal } from '../../Atoms/DeleteConfirmModal';
import { QuestionnaireS } from '../../Service/QuestionnaireS';
import SaveTemplateName from '../../Molecules/Document/SaveTemplateName';
import { useModalState } from '../../Molecules/Dialogs';

interface Props {
  id: number;
}

const QuestionnaireActions: FC<Props> = ({ id }) => {
  const navigate = useNavigate();
  const { show, toggle } = useModalState(false);

  const deleteQuestionnaire = async () => {
    openDeleteConfirmModal({
      title: 'Fragebogen löschen?',
      description: 'Möchtest Du wirklich diesen Fragebogen löschen?',
      onConfirm: async () => {
        const removed = await QuestionnaireS.deleteQuestionnaire(id);
        if (removed) {
          navigate(-1);
        }
        return removed;
      },
    });
  };

  return (
    <Menu radius="md" shadow="md" width={180} transition="slide-down" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item icon={<IconDeviceFloppy size={16} />} onClick={toggle}>
          Vorlage speichern
        </Menu.Item>
        <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={deleteQuestionnaire}>
          Löschen
        </Menu.Item>
      </Menu.Dropdown>
      <SaveTemplateName entityId={id} open={show} close={toggle} documentType={undefined} />
    </Menu>
  );
};

export default QuestionnaireActions;
